<template>
    <br>
    <div class="container mb-2">
        <div class="row">
            <div class="col-md-8 mt-2">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-2 mt-2">Direcciones</p>
                        </div>
                    </div>
                    <div v-for="(item, index) in jAddress" :key="index" class="mb-2"><!--v-for-->
                        <div :class="{ 'contenedor': true, 'expandido': expanded[index] }">
                            <div class="card-body">
                                <div class="row">
                                    <div class="d-flex">
                                        <div class="p-2">
                                            <h5 style="text-align: start; padding-left: 20px;" class="mb-2">Dirección {{ item.num_address }}</h5>
                                        </div>
                                        <div class="ms-auto p-2">
                                            <a class="btn-comment"  @click="opModal(index, jAddress[index])"><i class="pi pi-pencil" style="color:#000"></i></a>
                                            <a class="btn-comment" @click="toggleExpansion(index)">{{ btnMessage[index] }}</a>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Calle" v-model="item.street" disabled>
                                            <label for="ficalle">*Calle</label>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Colonia" v-model="item.numext" disabled>
                                            <label for="ficalle">*Num. Ext.</label>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Colonia" v-model="item.numint" disabled>
                                            <label for="ficalle">*Num. Int.</label>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Colonia" v-model="item.cp" disabled>
                                            <label for="ficalle">*C.P.</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Colonia" v-model="item.col" disabled>
                                            <label for="ficalle">*C.P.</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Colonia" disabled>
                                            <label for="ficalle">*Colonia</label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-floating mb-3">
                                            <input type="text" class="form-control" id="ficalle" placeholder="Colonia" disabled>
                                            <label for="ficalle">*Estado</label>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-floating">
                                            <textarea class="form-control" placeholder="Caracteristicas" id="floatingTextarea2" style="height: 100px" disabled></textarea>
                                            <label for="floatingTextarea2">Caracteristicas</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Divider type="solid" class="mt-2 mb-2"/>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-2">
                <div class="card card-profile" v-for="(item, index) in jUser">
                    <span class="edtPro pi pi-pencil" data-bs-toggle="modal" data-bs-target="#exampleModal" style=""></span>
                    <img loading="lazy" :src="item.cover"  alt="Image placeholder" class="card-img-top" />
                    <div class="row justify-content-center">
                        <div class="col-4 col-lg-4 order-lg-2">
                            <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0">
                                <Avatar :image="base64Image" class="mr-2" size="xlarge" shape="circle" />
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col">
                                <div class="d-flex justify-content-center">
                                    <div class="d-grid text-center"><span class="text-lg font-weight-bolder">{{ item.sale }}</span><span class="text-sm opacity-8">Compras</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-4">
                            <p style="font-size: 22px;">{{ item.name }} {{ item.lastname }}</p>
                            <div class="h6 font-weight-300 mt-2">
                                {{ item.email }}
                            </div>
                            <div class="h6 font-weight-300 mt-2">Cumpleaños: {{ item.birth }}</div>
                            <div class="h6 mt-2">Fecha de inicio: {{ item.date }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Editar perfil</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div>
                        <img loading="lazy" :src="base64Image" alt="Converted Image" style="width: 100px; height: 100px; border-radius: 25px;"/><br>
                    </div>
                    <div style="height: 70%;" class="mt-3 d-flex flex-column justify-content-center ">
                        <label class="text-start">Fotografía no mayor a 600px x 600px</label>
                        <div class="input-group mb-2">
                            <input class="form-control" type="file" id="formFileMultiple" accept="image/jpeg, image/jpg, image/png" @change="handleFileChange">
                        </div>
                        <label class="text-start">Fecha de nacimiento: </label>
                        <div class="input-group mb-2">
                            <input required type="date" class="form-control" placeholder="Correo" aria-label="Username" aria-describedby="basic-addon1" style="height: 50px; width: 80%;">
                        </div>
                        <label class="text-start">Contraseña*</label>
                        <div class="input-group mb-2">
                            <input  :type="typePass" class="form-control" placeholder="Contraseña" aria-label="Username" aria-describedby="basic-addon1" style="height: 50px; width: 80%;">
                            <span class="input-group-text pass" @click="showPassF" id="basic-addon1" style="height: 50px;"><i :class="{'pi':true,'pi-eye':!showPass, 'pi-eye-slash': showPass}" style="color: #000;"></i></span>
                        </div>
                        <label class="text-start">Repetir contraseña*</label>
                        <div class="input-group mb-3">
                            <input  :type="typePass" class="form-control" placeholder="Repetir ontraseña" aria-label="Username" aria-describedby="basic-addon1" style="height: 50px; width: 80%;">
                            <span class="input-group-text pass" @click="showPassF" id="basic-addon1" style="height: 50px;"><i :class="{'pi':true,'pi-eye':!showPass, 'pi-eye-slash': showPass}" style="color: #000;"></i></span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    <button type="button" class="btn btn-primary">Guardar cambios</button>
                </div>
            </div>
        </div>
    </div>

    <ModalSV v-show="vopMo" :jAddressM="jObjectAddress" :index="idxMo" @cerrarModal="vopMo = false"/>
</template>

<script>
import Swal from 'sweetalert2'
import { sliderService } from '@/services/sliderService';
import ModalSV from '@/components/ModalSV.vue';
import { ApiService } from '@/services/ApiService.js';
import {ref, onMounted, onBeforeUnmount} from 'vue';
export default {
    props:{},
    components:{
        ModalSV,
    },
    data(){
        return {
            jUser: [],
            jAddress: [],
            expanded: [],
            jObjectAddress: {},
            btnMessage: ['Ver más','Ver más','Ver más'],
            vopMo: false,
            idxMo: 0,
            typePass: 'password',
            base64Image: 'data:image/png;base64,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',
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    mounted: function(){
        if (localStorage.juserl) {//Verificamos que existe el objeto juserl
            if((localStorage.juserl).length < 1) this.$router.push({ path: '/login', replace: true })//Validamos si no hay usuarios
			this.jUser = localStorage.juserl;
			this.$store.commit('setMyVariable', JSON.parse(this.jUser));
		}else this.$router.push({ path: '/perfil', replace: true })
        sliderService.getDataUser().then((data) => (this.jUser = data));
        sliderService.getAllAddress().then((data) => (this.jAddress = data));
    },
    unmounted () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods:{
        handleScroll() {
            // Lógica que se ejecutará al hacer scroll
            console.log('Se hizo scroll');
            // Puedes realizar acciones adicionales aquí
        },
        showPassF(){
            this.showPass = !this.showPass;
            if(this.showPass) this.typePass = 'text'
            else this.typePass = 'password'
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                // Verificar el tipo de archivo
                const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: "error",
                        title: "Solo se permiten archivos JPEG, JPG o PNG.",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    return;
                }
                // Verificar el tamaño de la imagen
                const maxSize = 600; // Tamaño máximo permitido (en píxeles)
                const img = new Image();
                img.src = URL.createObjectURL(file);
                img.onload = () => {
                    if (img.width > maxSize || img.height > maxSize) {
                        Swal.fire({
                            icon: "error",
                            title: "La imagen no puede ser mayor de 600x600 píxeles.",
                            showConfirmButton: false,
                            timer: 1500
                        });
                    } else {
                        // Convertir la imagen a base64
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            // `e.target.result` contiene la representación en base64 de la imagen
                            this.base64Image = e.target.result;
                        };
                        // Leer el contenido del archivo como una URL de datos (base64)
                        reader.readAsDataURL(file);
                    }
                };
            }
        },
        toggleExpansion(index) {
            this.expanded[index] = !this.expanded[index];
            this.btnMessage[index] = this.expanded[index] == true ? 'Ver menos' : "Ver más";
        },
        opModal(index, jAd){
            this.idxMo = index + 1;
            this.jObjectAddress = jAd;
            this.vopMo = true;
        }
    }
}
</script>

<style scoped>
.edtPro{
    cursor: pointer; 
    position: absolute; 
    padding: 10px;
    top: 5px; 
    right: 5px; 
    z-index: 999;
}
.edtPro:hover{
    color: #000;
    border-radius: 20%;
    background: rgba(133, 133, 133, 0.267);
}
.contenedor {
    height: 200px; /* Tamaño inicial */
    overflow: hidden;
    position: relative;
    transition: width 0.3s ease; /* Transición suave */
    box-shadow: inset 0 -10px 10px -10px rgba(0, 0, 0, 0.5); /* Sombra interna en la parte inferior */
}

.btn-comment {
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
}

.btn-comment:hover {
    background: rgba(133, 133, 133, 0.267);
}

.expandido {
    height: auto; /* Tamaño expandido */
    box-shadow: none;
    border-bottom: 2px solid rgba(158, 158, 158, 0.8);
}
</style>